import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useState, useEffect } from "react";
import CanonicalUrl from "@components/layout/CanonicalUrl";
import ProductView from "@components/views/Product";
import CustomError from "@components/core/CustomError/CustomError";
import { getProduct } from "@utils/call-api/products-call";
import catalogContexts from "@utils/constants/catalogContexts";

const ProductShow = ({ productInit, productSlug, context }) => {
  const [product, setProduct] = useState(productInit);
  const [error, setError] = useState(false);

  useEffect(() => {
    async function fetchInitData() {
      if ([product?.slug, product?.uid, product?.id].includes(productSlug)) return;

      try {
        const productRes = await getProduct(productSlug);

        setProduct(productRes);
      } catch (err) {
        setError(err.response);
      }
    }

    fetchInitData();
  }, [productSlug, product]);

  if (error) return <CustomError statusCode={error.status} />;

  return (
    <>
      <CanonicalUrl />

      {productSlug === product?.slug && (
        <ProductView
          product={product}
          context={context}
        />
      )}
    </>
  );
};

export async function getServerSideProps({ locale, query, req }) {
  try {
    const jwt = req.cookies["jwt-token"];
    const productSlug = query.slug;
    const productInit = jwt ? null : await getProduct(productSlug, locale);
    const context = query?.context || catalogContexts.swap;

    return {
      props: {
        productInit,
        productSlug,
        context,
        headerBehaviors: { noHead: true, context, routerTransition: true },
        ...(await serverSideTranslations(locale, ["common", "product", "catalog", "reviews"])),
      },
    };
  } catch (err) {
    if (err.response.status === 404) return { notFound: true };
    throw err;
  }
}

ProductShow.requireAuth = false;

export default ProductShow;
